import { LegalPageLayout } from '@/components/legal-page-layout'

const EU_COUNTRIES = [
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czechia',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Ireland',
  'Italy',
  'Latvia',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Netherlands',
  'Poland',
  'Portugal',
  'Romania',
  'Sweden',
  'Slovakia',
  'Slovenia',
  'Spain',
]

export default function LegalTaxes() {
  return (
    <LegalPageLayout title="Git Digest Taxes" lastUpdated="October 4, 2024">
      <section className="mb-6">
        <p className="mb-4">
          Where our Service is taxable, we collect and remit consumption tax to governments at the local, state, and/or
          federal levels. If your billing address is in one of the following jurisdictions, you&apos;ll see an
          additional line item on your invoice for sales tax or VAT. The subscription prices on our service websites are
          all exclusive of sales tax and VAT.
        </p>
        <p className="mb-4">
          The tax rate and rules are determined by each jurisdiction and sometimes vary based on whether you are using
          our Service for business/commercial or personal purposes. As regulations change, we will update this list.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2 text-2xl">Jurisdictions we collect and remit taxes for</h2>
        <h3 className="mb-2 text-xl">Within the EU</h3>
        <p className="mb-4">
          We collect VAT on any direct-to-consumer sales to EU-based customers. If you are a Git Digest customer with a
          VAT identification number, let us know and we will apply a reverse charge for VAT to your invoice.
        </p>
        <ul className="grid list-inside list-disc grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3">
          {EU_COUNTRIES.map((country) => (
            <li key={country}>{country}</li>
          ))}
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="mb-2 text-xl">Within the US</h3>
        <p className="mb-4">We collect and remit sales tax on any direct-to-consumer sales to US-based customers.</p>
      </section>

      <section>
        <h2 className="mb-2 text-2xl">We&apos;re here to help</h2>
        <p className="mb-4">Please contact our Support team if you have any issues or if:</p>
        <ul className="list-inside list-disc space-y-2">
          <li>You believe you&apos;re being charged in error.</li>
          <li>
            Your organization is tax exempt or has a VAT identification number. Alongside your tax exempt certification
            or VAT identification number, please include your organization ID when you email us. Your organization ID
            can typically be found in a URL when you are in the application (i.e.:
            gitdigest.ai/[organization_id]/dashboard)
          </li>
          <li>You have any additional questions.</li>
        </ul>
      </section>
    </LegalPageLayout>
  )
}
